import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { d as defineCustomElement$3 } from './p-C78HRAnj.js';
import { d as defineCustomElement$2 } from './p-Cr5d_5Z4.js';
import { d as defineCustomElement$1 } from './p-CZA0kb6w.js';

const closeButtonCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:inline-flex;flex:none;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host button{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;background:none;border:none;border-radius:.25rem;box-sizing:border-box;cursor:pointer;display:inline-flex;font-family:Open Sans;font-size:.875rem;font-weight:400;font-weight:inherit;justify-content:center;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;margin:0;padding:0;-webkit-user-select:none;user-select:none}:host button *,:host button :after,:host button :before{box-sizing:inherit}:host button img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host button[disabled]{cursor:not-allowed}:host button:focus{outline:none}:host button:disabled{opacity:var(--jw-theme-surface-item-disabled-opacity)}:host button:not([disabled]):focus{outline:var(--jw-theme-effects-focus-default-outline)}:host([type=muted]) button{background-color:var(--jw-theme-surface-muted-close-default-bg-color)}:host([type=muted]) button wui-icon{color:var(--jw-theme-surface-muted-close-default-color)}:host([type=muted]) button:not([disabled]):hover{background-color:var(--jw-theme-surface-muted-close-hover-bg-color)}:host([type=muted]) button:not([disabled]):hover wui-icon{color:var(--jw-theme-surface-muted-close-hover-color)}:host([type=muted]) button:not([disabled]):active{background-color:var(--jw-theme-surface-muted-close-active-bg-color)}:host([type=muted]) button:not([disabled]):active wui-icon{color:var(--jw-theme-surface-muted-close-active-color)}:host([type=bold]) button{background-color:var(--jw-theme-surface-bold-close-default-bg-color)}:host([type=bold]) button wui-icon{color:var(--jw-theme-surface-bold-close-default-color)}:host([type=bold]) button:not([disabled]):hover{background-color:var(--jw-theme-surface-bold-close-hover-bg-color)}:host([type=bold]) button:not([disabled]):hover wui-icon{color:var(--jw-theme-surface-bold-close-hover-color)}:host([type=bold]) button:not([disabled]):active{background-color:var(--jw-theme-surface-bold-close-active-bg-color)}:host([type=bold]) button:not([disabled]):active wui-icon{color:var(--jw-theme-surface-bold-close-active-color)}:host([size=sm]) button{height:1rem;width:1rem}:host([size=sm]) button wui-icon{height:.75rem;width:.75rem}:host([size=sm]) button:not([disabled]):focus{outline:var(--jw-theme-effects-focus-sm-outline)}:host([size=md]) button{height:1.5rem;width:1.5rem}:host([size=md]) button wui-icon{height:1rem;width:1rem}:host([size=lg]) button{height:2rem;width:2rem}:host([size=lg]) button wui-icon{height:1.25rem;width:1.25rem}:host([size=xl]) button{height:2.5rem;width:2.5rem}:host([size=xl]) button wui-icon{height:1.5rem;width:1.5rem}";

const WuiCloseButton = /*@__PURE__*/ proxyCustomElement(class WuiCloseButton extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.type = 'muted';
        this.size = 'md';
        this.disabled = false;
        this.tooltip = 'Close';
        this.icon = 'x';
    }
    // Prevent clicks from emiting on this element if it's disabled
    _handleClick(e) {
        if (this.disabled) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
    render() {
        return (h(Host, { key: 'ba64650d5152a97c10f49514edcd475babe378e6', "aria-label": this.tooltip, role: "button" }, h("wui-tooltip", { key: 'adf462cff0ed161221286dc66038b5cf75842ef2', disabled: this.disabled, label: this.tooltip }, h("button", { key: 'ad6e8e1ea6da920b582707d5d1211f5b87b1b8cf', type: "button", disabled: this.disabled }, h("wui-icon", { key: 'eec9416f9ccc59f5389ae51afa15a9fdf1fdb7bd', name: this.icon })))));
    }
    static get style() { return closeButtonCss; }
}, [257, "wui-close-button", {
        "type": [513],
        "size": [513],
        "disabled": [516],
        "tooltip": [1],
        "icon": [1]
    }, [[2, "click", "_handleClick"]]]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-close-button", "wui-icon", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiCloseButton);
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiCloseButton as W, defineCustomElement as d };
